import { render, staticRenderFns } from "./router.vue?vue&type=template&id=6f35b0fe&scoped=true&"
import script from "./router.vue?vue&type=script&lang=js&"
export * from "./router.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f35b0fe",
  null
  
)

export default component.exports